import { render, staticRenderFns } from "./TestsHistoryView.vue?vue&type=template&id=54ff6b0e&scoped=true"
import script from "./TestsHistoryView.vue?vue&type=script&lang=js"
export * from "./TestsHistoryView.vue?vue&type=script&lang=js"
import style0 from "./TestsHistoryView.vue?vue&type=style&index=0&id=54ff6b0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ff6b0e",
  null
  
)

export default component.exports